import {createMuiTheme, MuiThemeProvider} from "@material-ui/core";
import CssBaseline from "@material-ui/core/CssBaseline";
import * as React from "react";
import {Router, Route, Switch} from "react-router-dom";
import SinglePathFinder from './components/SinglePathFinder/SinglePathFinder';
import {Context} from './store/context';
import store from './store/index';
import './Root.css';
import Navbar from './components/Navbar/Navbar';
import {createBrowserHistory} from "history";
import GettingToPage from "./pages/getting-to/GettingToPage";
import {Routes} from "./routes";
import { AnalyticsEvents, ScrollSpeedObserver } from "./store/AnalyticsStore";
import SiteTitle from "./components/SiteTitle/SiteTitle";
import Footer from "./components/Footer/Footer";
import { analytics } from ".";


export const customHistory = createBrowserHistory();
const theme = createMuiTheme({
  spacing: 8
});

const isEmbeded = window.self !== window.top

export const Root = () => {
  React.useEffect(() => {
    analytics.logEvent(AnalyticsEvents.SessionStart)
  }, [])

  return (
    <ScrollSpeedObserver>
      <Context.Provider value={store}>
          <SiteTitle />
          <Router history={customHistory}>
              <MuiThemeProvider theme={theme}>
                  <CssBaseline/>
                  <div className="page-container" data-isembeded={isEmbeded}>
                      <div className="page-content">
                          <div className="content-wrapper">
                              <div className="container">
                                <Switch>
                                  <Route path={Routes.PhotoRoute} component={SinglePathFinder}/>
                                  <Route path={process.env.PUBLIC_PATH + Routes.PhotoRoute} component={SinglePathFinder}/>
                                  <Route path={Routes.GettingTo} component={GettingToPage}/>
                                  <Route path={process.env.PUBLIC_PATH + Routes.GettingTo} component={GettingToPage}/>
                                </Switch>
                              </div>
                          </div>
                      </div>
                  </div>
                  {/* The rest of your application */}
                  {!isEmbeded && <Footer />}
              </MuiThemeProvider>
          </Router>
      </Context.Provider>
    </ScrollSpeedObserver>
  );
};
